const LIGHT_ARROW = '/ats/icons/arrow-right-light-icon.svg';
const DARK_ARROW = '/ats/icons/arrow-right-black-icon.svg';

const theme = (background, tone) => ({
	background,
	tone,
	arrowIcon: tone === 'light' ? LIGHT_ARROW : DARK_ARROW
});

// Card headers walk through this palette in order so a full grid keeps the
// alternating rhythm of the design. `tone` is the color of the text sitting on
// top of the background, not the background itself.
export const openJobCardThemes = [
	theme('#6172F3', 'light'),
	theme('#E8FAF6', 'dark'),
	theme('#9B8AFB', 'light'),
	theme('#59F3D4', 'dark'),
	theme('#D5D7DA', 'dark'),
	theme('#717BBC', 'light'),
	theme('#A4A7AE', 'light')
];

export const getOpenJobCardTheme = index =>
	openJobCardThemes[index % openJobCardThemes.length];
